import {deserialize} from 'libs/cerialize';

export class SpreadsheetPageDescriptorDto {
    @deserialize
    PageName: string;

    @deserialize
    PageDisplayName: string;
}